/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
    if ($(".mw_wp_form.mw_wp_form_input .error").length > 0) {
      $('.c-accordion__content.is-form').show();
    }

    if ($('.mw_wp_form').hasClass('mw_wp_form_confirm')) {
      $('.c-accordion__content.is-form').show();
      $('.c-forms-simple__content small').hide();
    }
  };

  growApp.prototype.myCountUp = function () {
    function numberCountUp() {
      var selector = '.js-countup';     // 対象のDOMのセレクタ
      var $years = $(selector);
      $years.each(function () {
        var year = $(this).text();
        $(this).text(year - 100);
        var tempyear = year - 100;
        var self = this;
        var scrollStart = function () {
          if (($(self).offset().top - 700) < $(window).scrollTop()) {
            var interval = setInterval(function () {
              if (tempyear < year) {
                tempyear++;
                $(self).text(tempyear);
              } else {
                clearInterval(interval);
                return false;
              }
            }, 15)
          } else {
            window.requestAnimationFrame(scrollStart)
          }
        }
        window.requestAnimationFrame(scrollStart)
      });
    }

    $(function () {
      numberCountUp();
    })

  };

  growApp.prototype.navClose = function () {
    function navOutClose() {
      var slideMenu = $('.c-slidebar-menu');


      $('.c-slidebar-container').on('click', function (e) {
          // if (!$(e.target).closest('.c-slidebar-menu, .c-slidebar-button, .l-header-minimal__button, .l-header-minimal__heading').length) {
          // }
            $('body').removeClass('is-slidebar-active');
      })
    }

    $(function () {
      navOutClose();
    })

  };



  $(function () {
    var app = new growApp();
    app.myCode();
    app.myCountUp();
    app.navClose();
  });
})(jQuery);
